module.exports = __webpack_public_path__ + "img/2.f20a92d6.webp";